import React from 'react';

export default function useIsElementFocused(elementRef: React.RefObject<HTMLElement>) {
  const [isFocused, setIsFocused] = React.useState(false);

  const handleFocus = () => setIsFocused(true);

  const handleBlur = () => setIsFocused(false);

  React.useEffect(() => {
    const current = elementRef.current;

    if (current) {
      current.addEventListener('focus', handleFocus);
      current.addEventListener('blur', handleBlur);
    }
    return () => {
      if (current) {
        current.removeEventListener('focus', handleFocus);
        current.removeEventListener('blur', handleBlur);
      }
    };
  }, [elementRef]);

  return isFocused;
}
